<div class="issue-container">
    <app-ex-issuerrortype [errortypeObj]="{issueType:issue.type,iconSize:'fa-2x'}"></app-ex-issuerrortype>
    <b class="ml-2">{{ui_errortype(issue)}}</b>
    <div>Relevance:<app-issuerelevance [issue]="issue"></app-issuerelevance></div>
<!--     <table *ngIf="options.showDate" class="issue-info-table imagedate issue-measures">
        <tr>
            <th>Image Date/Time</th>
            <td>{{issue.info?.date | date:'dd-MM-yyyy HH:mm:ss' }}</td>
        </tr>
    </table> -->
    <div><span class="image-time">Image Date/Time: {{issue.info?.date | date:'dd-MM-yyyy HH:mm:ss' }}</span></div>
    <div>
        <table class="issue-info issue-measures">
            <tr>
                <th class="title-section" colspan=2><i
                        class="fas fa-thermometer-half"></i> Measures</th>
            </tr>
            <tr>
                <th>Max</th>
                <td>{{issue.info?.temperature?.max | number: '2.2-2' }} ºC</td>
            </tr>
            <tr *ngIf="showTempMeasuresMin">
                <th>Min</th>
                <td>{{issue.info?.temperature?.min | number: '2.2-2' }} ºC</td>
            </tr>
            <tr>
                <th>Average</th>
                <td>{{issue.info?.temperature?.mean | number: '2.2-2' }} ºC</td>
            </tr>
            <tr>
                <th>Thermal Gradient</th>
                <td>{{issue.info?.temperature?.gradient | number: '2.2-2' }} ºC
                    <app-issuerelevance [issue]="issue" [showDesc]="false">
                    </app-issuerelevance>
                </td>
            </tr>
            <tr>
                <th>Thermal Gradient at 1000W/m2</th>
                <td>{{issue.info?.temperature?.gradient_1kw | number: '2.2-2' }}
                    ºC</td>
            </tr>
        </table>

    </div>
</div>